// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DragOutlinedSvg from "@fishx/icons-svg/es/asn/DragOutlined";
import FishxIcon from '../components/FishxIcon';

var DragOutlined = function DragOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DragOutlinedSvg
  }));
};

DragOutlined.displayName = 'DragOutlined';
export default React.forwardRef(DragOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DragOutlined.js
// module id = 2467
// module chunks = 0